import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Col, Container, Row } from "react-bootstrap";
import Nav from "./Navbar";
import Footer from "./Footer";
import tool13 from "../Images/tool13.png";
import tool12 from "../Images/tool12.png";
import Domainpage from "./Dapa";
const Domainage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
    const script = document.createElement("script");
    script.type = "module";
    script.src = "/off_seo.js";
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, []);

  return (
    <Container fluid className="p-0" style={{ overflowX: "hidden" }}>
      <div>
        {/* <div
          className="d-flex justify-content-center"
          style={{ background: "#fdca40" }}
        >
          <p className="p-2 m-0 text-center">
            Start with free trial of <b>SeoBix!</b> - boost your SEO
            game&nbsp;&nbsp;
            <Button size="sm" variant="success">
              Know More
            </Button>
          </p>
        </div> */}
        <Nav />
      </div>

      <Row className="d-flex justify-content-center mt-4">
        <Col className="col-md-10 col-12 ">
          <div className=" mx-2  mb-5">
            <h1 className="text-center m-4">
              Domain Age Checker:Track your website journey
            </h1>
            <div
          className=" mt-md-5 p-4 "
          style={{
            background:
              "linear-gradient(to right, #AFDDFF 0%, #C5E7FF 30%, #DAF0FF 60%, #EDF8FF 85%, #FFFFFF 100%)",
          }}
        >
          <h2
            style={{ color: "#0A3981" }}
            className="d-flex justify-content-center pt-5"
          >
            <b> Check Your Domain Authority and Age Instantly</b>
          </h2>
          <Domainpage />
        </div>
            <p className="mt-md-4 mt-2">
              Domain age is one of the key parameters that determine the trust
              it earns in search engines and its overall ranking. With the
              domain age checker, you can see the lengths of your website in
              terms of its history and how long-lived it is on the web. Let us
              see more closely how domain age importance relates to SEO and how
              it affects it again.
            </p>
            <div className="d-flex justify-content-center">
              <img
                className="m-3"
                src={tool12}
                alt="seobix"
                style={{ width: "70vw" }}
              />
            </div>
            <h2>Created On: A Look at Your Site’s Roots</h2>
            <p>
              The date of creation for any domain marks the age of its online
              presence. Search engines are trusted towards older domains as they
              generally take them as authoritative ones. Therefore, knowing when
              your domain was created allows you to assess the authority and
              reliability of your website. Moreover, an age domain can help you
              in finding any edge when competing on fresh websites.
            </p>
            <mark>
              Tip: To maximize the benefits of an older domain, pair it with the
              best structured data tools for small businesses to enhance content
              indexing and visibility.
            </mark>
            <h2>Updated On: Keeping Your Domain Relevant</h2>{" "}
            <p className="">
              In general, updating a domain shows search engines that the
              website has been working and evolving continuously. The modified
              on date will tell one when the domain was last modified or when
              its content went modified. A new domain with currently updated
              content will probably rank better and attract visitors..
            </p>
            <mark>
              Tip: Regular updates combined with structured data can increase
              website traffic with structured data, ensuring that search engines
              can easily find and present your updated content.
            </mark>
            <h2>Age Checker: Assessing Domain Strength</h2>{" "}
            <p className="">
              The age-checking instrument gives important insights regarding how
              long your domain might have been online. A domain that has been
              around for a longer time appears to gain more authority and trust
              by search engines. A good understanding of your domain age is
              important in assessing its SEO possibilities and planning for
              future growth.
            </p>
            <mark>
              Tip: Combine age-checking insights with structured data strategies
              to maintain a robust SEO foundation and long-term traffic growth.
            </mark>
            <h2>Expiry Date: Don’t Lose Your Domain’s Authority</h2>
            <p>
              An expired domain should not be taken lightly because it can cause
              a huge blow to your SEO rankings and the trust-worthiness of your
              site. Track the expiration date and have your house in order with
              timely renewal so that your SEO efforts do not cause any
              discontinuities.
            </p>
            <div className=" mb-3 d-flex justify-content-center">
              <img
                style={{ width: "50vw" }}
                className="mb-3"
                src={tool13}
                alt="seobix"
              />
            </div>
            <mark>
              Tip: A well-maintained domain, with continuous updates and
              structured data optimization, can significantly increase website
              traffic with structured data, keeping you ahead of competitors.
            </mark>{" "}
          </div>
        </Col>
      </Row>

      <div
        className="m-0 p-0"
        style={{
          overflow: "hidden",
          background: "#31393C",
          borderTopRightRadius: "2rem",
          borderTopLeftRadius: "2rem",
        }}
      >
        <Footer />
      </div>
    </Container>
  );
};

export default Domainage;
